import React from 'react';

interface ITextsContainerProps {
  children: React.ReactNode;
}

export const TextsContainer: React.FC<ITextsContainerProps> = ({
  children,
}) => <div className="tw-flex tw-w-full tw-flex-col tw-gap-1">{children}</div>;
